import { observable, set, computed } from 'mobx';
import { IContentObjListItem, IToutItem } from '../../interfaces/ISearchInterfaces';
import { RESULT_TYPE, contentSize, TOUT_COUNT } from '../../constants/Search';

export interface ISearchContentCatalog {
    contentObjListItems: IContentObjListItem[];
    firstRecNum: number;
    lastRecNum: number;
    totalNumRecs: number;
}

export class SearchContentCatalog {
    @observable private contentItems: IContentObjListItem[] = [];
    @observable private toutItems: IToutItem[] = [];
    @observable private firstRecNum: number;
    @observable private lastRecNum: number;
    @observable private toutGridPlacement: number;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static fromJSON(data: any): SearchContentCatalog {
        const searchContentCatalog = new SearchContentCatalog();
        set(searchContentCatalog, data);

        return searchContentCatalog;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public update = (data: any) => {
        set(this, data);
        this.contentItems = [];
        this.toutItems = [];
        this.toutGridPlacement = 1;
        this.firstRecNum = data.firstRecNum;
        this.lastRecNum = data.lastRecNum;

        const catalog: ISearchContentCatalog = {
            contentObjListItems: data.contentObjListItems,
            firstRecNum: data.firstRecNum,
            lastRecNum: data.lastRecNum,
            totalNumRecs: data.totalNumRecs
        };

        if (catalog.contentObjListItems.length) {
            this.contentItems = catalog.contentObjListItems;

            this.contentItems.forEach((contentObjListItem) => {
                switch (contentObjListItem.type) {
                    case RESULT_TYPE.TOUT:
                        const tout = this.createTout(contentObjListItem);
                        this.toutItems.push(tout);
                        this.toutGridPlacement++;
                        break;
                    case RESULT_TYPE.VIDEO:
                        const videoTout = this.createTout(contentObjListItem);
                        this.toutItems.push(videoTout);
                        this.toutGridPlacement++;
                        break;
                    default:
                }
            });
        }

        if (catalog.firstRecNum) {
            this.firstRecNum = catalog.firstRecNum;
        }

        if (catalog.lastRecNum) {
            this.lastRecNum = catalog.lastRecNum;
        }

        if (catalog.totalNumRecs) {
            this.lastRecNum = catalog.totalNumRecs;
        }
    };

    private createTout(toutItem: IContentObjListItem): IToutItem {
        const pageRecords = this.lastRecNum - this.firstRecNum;

        if (pageRecords < TOUT_COUNT) {
            this.toutGridPlacement = this.toutGridPlacement + 2;
        } else {
            this.toutGridPlacement = this.toutGridPlacement + Math.round(pageRecords / TOUT_COUNT);
        }

        const tout: IToutItem = {
            nId: toutItem.nId,
            nPsn: this.toutGridPlacement,
            nSize: contentSize.small
        };

        return tout;
    }

    @computed
    public get content() {
        return this.contentItems;
    }

    @computed
    public get touts() {
        return this.toutItems;
    }

    @computed
    public get numContentRecs() {
        return {
            toutsRecNumber: this.toutItems.length,
            contentRecNumber: this.contentItems.length
        };
    }
}
